import { LoadingOverlay } from '@mantine/core';
import { useGetPaymentPlan, useUpdatePaymentPlan } from 'api';
import type { PaymentStepsAttributes } from 'api/models';
import { i18nKeys, useTranslation } from 'locales';
import { omit } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import {
  type PartialUpdatePaymentPlanBody,
  PaymentPlanEditFormSteps,
} from './PaymentPlanEditFormSteps';

export const PaymentPlanEditForm = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id: paymentPlanId } = useParams<{ id: string }>();

  const { data: paymentPlanResponse, isLoading, isError } = useGetPaymentPlan(paymentPlanId);

  const { mutate: updatePaymentPlan } = useUpdatePaymentPlan();

  const [paymentSteps, setPaymentSteps] = useState<PaymentStepsAttributes[]>([]);

  useEffect(() => {
    if (paymentPlanResponse) {
      const {
        data: {
          attributes: { payment_steps_attributes },
        },
      } = paymentPlanResponse;

      setPaymentSteps(
        payment_steps_attributes.map(e => omit({ id: e.id, ...e.attributes }, ['days_late'])),
      );
    }
  }, [paymentPlanResponse]);

  if (isLoading && !paymentPlanResponse) {
    return <LoadingOverlay visible />;
  }

  if (isError || !paymentPlanResponse) {
    return <span>{t(i18nKeys.PAYMENT_PLAN.ERROR)}</span>;
  }

  const { data: paymentPlan } = paymentPlanResponse;

  return (
    <PaymentPlanEditFormSteps
      paymentPlan={paymentPlan}
      paymentSteps={paymentSteps}
      onSubmit={(data: PartialUpdatePaymentPlanBody) => {
        updatePaymentPlan(
          { id: paymentPlanId, data },
          {
            onSuccess: () => {
              history.push(`/payment-plans/${paymentPlanId}`);
            },
          },
        );
      }}
    />
  );
};
